import _omit from 'lodash/omit';
import _pick from 'lodash/pick';
import _get from 'lodash/get';
import getMultiroomParamsByConfig from './getMultiroomParamsByConfig';
import { HotelsConfig, Query } from '../types';
import convertRoomsForQuery from './convertRoomsForQuery';
import { getCurrentRooms } from './getCurrentSearchParams';

const applyHotelsConfigRestrictions = (query: Query, hotelsConfig: HotelsConfig): Query => {
  const { hasMultiroom, maxGuestsCount } = getMultiroomParamsByConfig(hotelsConfig);
  const { rooms } = getCurrentRooms(query, hasMultiroom, maxGuestsCount);

  let checkIOTimes = {};

  if (_get(hotelsConfig, 'features.check_dates_options', false)) {
    checkIOTimes = _pick(query, ['e_checkin', 'l_checkout']);
  }

  return {
    ..._omit(query, ['e_checkin', 'l_checkout']),
    ...checkIOTimes,
    rooms: convertRoomsForQuery(rooms),
  };
};

export default applyHotelsConfigRestrictions;
